import PropTypes from 'prop-types';

export const filingGroupPropTypes = PropTypes.shape({
  jurisdictionId: PropTypes.string,
  jurisdiction: PropTypes.string,
  filingGroupId: PropTypes.string,
  description: PropTypes.string,
});
